<template>
    <div class="d-flex pb-5">
        <input v-model="searchText" :placeholder="$t('shop.search')" @change="clearSearch()" aria-label="Search"
            aria-describedby="button-addon" :disabled="isInteractionLocked" class="form-control bg-white"
            @keyup.enter="searchItem" />
        <input type="number" :placeholder="$t('shop.productSearchBox.from')" v-model="pointsFrom" class="form-control"
            :disabled="isInteractionLocked"
            @keyup.enter="searchItem" />

        <input type="number" :placeholder="$t('shop.productSearchBox.to')" v-model="pointsTo" class="form-control"
            :disabled="isInteractionLocked"
            @keyup.enter="searchItem" />
        <MDBIcon icon="search" class="align-self-center ms-2" :class="{ 'cursor--pointer': !isInteractionLocked, 'search-icon--disabled': isInteractionLocked }" @click="searchItem()" />
    </div>
    <Loader :show="loader" v-if="loader" />
    <div v-else>
        <div v-if="searchProducts.length > 0" class="ps-2 pb-3 pt-3 mb-3 bg-white">
            <div v-for="(product, index) in searchProducts" :key="index" class="mb-2">
                <router-link :to="{ name: 'productDetails', params: { id: product.value } }" class="fw-bold ">
                    <div class="d-flex link-container">
                        <img :src="productImgSrc(product)" class="container__img" :alt="product.label" />
                        <p>{{
                            product.label }} -
                            {{ productPoints(product)
                            }} {{ $t('bankstatement.points') }}</p>
                    </div>
                </router-link>
            </div>
        </div>
    </div>

</template>

<script setup>
import { MDBIcon } from "mdb-vue-ui-kit";
import Loader from "../General/Loader/index.vue";
import { ref, onMounted, computed } from "vue";
import { ProductService } from "@/services/product.service";
import TokenService from "@/services/storage.service";
import { useStore } from "vuex";

const store = useStore();
const searchText = ref(null)
const searchProducts = ref([])
const pointsFrom = ref(null)
const pointsTo = ref(null)
const loader = ref(false)
const productRequestSent = computed(() => store.getters.getProductRequestSent);
const isInteractionLocked = computed(() => loader.value || productRequestSent.value);

const clearSearch = () => {
    searchProducts.value = []
}
const searchItem = async () => {
    if (isInteractionLocked.value) {
        return false
    }

    if (!searchText.value && !pointsFrom.value && !pointsTo.value) {
        return false
    }
    loader.value = true
    const text = searchText.value == '' ? null : searchText.value
    const pointsMin = pointsFrom.value == '' ? null : pointsFrom.value
    const pointsMax = pointsTo.value == '' ? null : pointsTo.value
    const response = await ProductService.getProductsByName(text, pointsMin, pointsMax)

    TokenService.setProductData(text, pointsFrom.value, pointsTo.value)
    if (response.length > 0) {
        searchProducts.value = response.map((item) => {
            return {
                label: item.name,
                value: item.id,
                points: item.points,
                images: item.imageUrl,
                variants: item.variants,
                type: item.type,
                has_variants: item.has_variants
            }
        })
    } else {
        searchProducts.value = []
    }

    loader.value = false
}

const productImgSrc = (data) => {
    return data.variants.length > 0
        ? data.variants[0]?.imageUrl
        : data.images;
};

const productPoints = (data) => {
    if (data.variants && data.variants.length > 0) {
        const pointsArray = data.variants
            .map(v => v.points)
            .filter(p => p !== null && p !== undefined);

        if (pointsArray.length === 0) return '';

        const min = Math.min(...pointsArray);
        const max = Math.max(...pointsArray);

        return min === max ? min : `${min}–${max}`;
    } else {
        return data.points;
    }
};

onMounted(async () => {
    searchText.value = TokenService.getProductName() == 'null' ? null : TokenService.getProductName()
    pointsFrom.value = TokenService.getProductPointsFrom()
    pointsTo.value = TokenService.getProductPointsTo()

    if (pointsTo.value == 'null' && pointsFrom.value == 'null' && !searchText.value) {
        return
    }

    if (pointsTo.value || pointsFrom.value || searchText.value) {
        await searchItem()
    }
})
</script>

<style scoped lang="scss">
@import "@/styles/product_search_box.scss";
</style>
